import React from 'react';

import { Chip, ChipProps, useTheme } from '@mui/material';

interface PropsType {
	status: 'Completed' | 'Rejected' | 'On inspection';
}

function ReportInfoBlockItemStatus({ status }: PropsType) {
	const theme = useTheme();
	let color: ChipProps['color'];
	if (status === 'Completed') return null;

	switch (status) {
		case 'On inspection':
			color = 'info';
			break;
		case 'Rejected':
			color = 'error';
			break;
		default:
			color = 'info';
	}

	return (
		<Chip
			label={status}
			sx={{
				width: 'fit-content',
				height: '20px',
				background: theme.palette[color].main,
				'& .MuiChip-label': {
					fontSize: '12px',
					fontWeight: 600,
					lineHeight: '18px',
					padding: '0px 10px',
					color: theme.palette[color].contrastText,
				},
			}}
		/>
	);
}
export default ReportInfoBlockItemStatus;
